<template>
  <div 
    class="d-flex flex-column align-items-center h-100 border-end gap-2 p-2 position-relative" style="overflow: hidden;"
  >
    <el-menu
      :default-active="pathActive"
      class="w-100 el-menu-vertical-demo border-0 flex-1"
      router
      @select="selectActive"
      active-text-color="#1769D7"
      :collapse="!menuOpen"
      @open="handleOpen" @close="handleClose"
    >
      <div  v-for="(item, index) in filteredMenuItems" :key="index">
        <el-menu-item v-if="!item.subItems.length" :index="item.path">
          <!-- Some entries prefer an inline SVG icon rather than the font
               glyph — matches the specific flaticon design chosen for
               Nhiệm vụ (checklist) and Lịch làm việc (event calendar). -->
          <span
            v-if="item.svg"
            class="me-2 sidebar-svg"
            :class="[!menuOpen ? 'd-flex align-items-center justify-content-center w-100 h-100' : '']"
            v-html="renderSvg(item.svg, isActive(item.path))"
          />
          <icon-font
            v-else
            style="margin-bottom: 1px"
            :class="!menuOpen ? 'd-flex align-items-center justify-content-center w-100 h-100' : ''"
            class="me-2"
            :color="isActive(item.path) && '#1769D7'"
            :name="item.icon"
          />
          <template #title>
            <span class="d-flex align-items-center" style="height: 36px">{{
              item.title
            }}</span></template
          >
        </el-menu-item>

        <el-submenu v-else :index="item.path">
          <template slot="title">
            <icon-font 
            style="margin-bottom: 1px;"
            :class="!menuOpen ? 'd-flex align-items-center justify-content-center w-100 h-100 me-0' : ''"
            class="me-2"
             :name="item.icon" 
            />
            <span v-if="menuOpen">{{ item.title }}</span>
          </template>

          <el-menu-item
            v-for="subItem in item.subItems"
            :key="subItem.path"
            :index="subItem.path"
          >
            <span class="sub-menu-title">{{ subItem.title }}</span>
          </el-menu-item>
        </el-submenu>
      </div>
    </el-menu>

    <div class="w-100 d-flex">
      <el-menu style="border: none;" :collapse="!menuOpen">
        <div>
          <el-menu-item index="1" @click="onClickMenu2(1)">
            <icon-font
              :class="!menuOpen ? 'd-flex align-items-center justify-content-center w-100 h-100' : ''"
              style="margin-bottom: 1px"
              class="me-2"
              name="icon-navigation-support"
            />
            <span slot="title">
              <div class="d-flex align-items-center" style="height: 36px">
                <span class="fw-500 font-12">Hỗ trợ trực tuyến</span>
                <span class="live-text">LIVE</span>
              </div>
            </span>
          </el-menu-item>
          <el-menu-item index="2" @click="onClickMenu2(2)">
            <icon-font
              :class="!menuOpen ? 'd-flex align-items-center justify-content-center w-100 h-100' : ''"
              style="margin-bottom: 1px"
              class="me-2"
              name="icon-navigation-guide" 
            />
            <span slot="title">
              <span
                class="d-flex align-items-center fw-500 font-12"
                style="height: 36px"
              >
                <span>Hướng dẫn sử dụng</span>
              </span>
            </span>
          </el-menu-item>
          <el-menu-item index="3" @click="onClickMenu2(3)" ref="surveyItem"
            class="position-relative">
            <transition name="fade">
              <div
                v-if="showArrow"
                class="arrow-tooltip position-absolute"
              >
                <div class="arrow-box">
                  <span class="arrow-text">🎯 Hãy chia sẻ ý kiến của bạn — chỉ mất 1 phút thôi!</span>
                  <div class="arrow-down"></div>
                </div>
              </div>
            </transition>
            <icon-font
              :class="!menuOpen ? 'd-flex align-items-center justify-content-center w-100 h-100' : ''"
              style="margin-bottom: 1px"
              class="me-2"
              name="icon-single-option"
            />
            <span slot="title">
              <span
                class="d-flex align-items-center fw-500 font-12"
                style="height: 36px"
              >
                <span>Khảo sát sản phẩm</span>
              </span>
            </span>
          </el-menu-item>
        </div>
      </el-menu>
    </div>
  </div>
</template>

<style scoped>
</style>

<script>
import IconFont from "./IconFont.vue";
export default {
  name: "SideBar",
  components: { IconFont },
  data() {
    return {
      showArrow: false,
      lastActivity: Date.now(),
      inactiveTimer: null,
      hideTimer: null,
      visibilityChangeTime: null,
      pathActive: "",
      menuItems: [
        {
          title: "Trang chủ",
          icon: "icon-navigation-dashboard",
          path: "/dashboard",
          subItems: [],
        },
        {
          title: "Khách hàng",
          icon: "icon-navigation-customer",
          path: "/contact",
          subItems: [],
          permission: ["CONTACT_READ"],
        },
        {
          title: "Nhiệm vụ",
          svg: "checklist",   // inline SVG picked in renderSvg()
          path: "/task",
          subItems: [],
        },
        {
          // "Làm việc" → calendar (appointment + task due dates) on its own
          // route so it's not buried under the task page's tab bar anymore.
          title: "Lịch làm việc",
          svg: "event",
          path: "/calendar",
          subItems: [],
        },
        // {
        //   title: "Marketing",
        //   icon: "icon-navigation-marketing",
        //   path: "/marketing",
        //   subItems: [],
        // },
        {
          title: "Báo cáo",
          icon: "icon-navigation-report",
          path: "/report",
          subItems: [],
          permission: ["SETTING_STATISTIC_READ"]
        },
        {
          title: "Thiết lập",
          icon: "icon-navigation-setting",
          path: "/setting",
          subItems: [
            {
              title: "Thiết lập chung",
              path: "/setting/general",
              permission: ["SETTING_ROLE_READ","SETTING_COMPANY_READ","SETTING_TEAM_READ","SETTING_USER_READ"]
            },
            {
              title: "Thiết lập quy trình",
              path: "/setting/sale-performance",
              permission: ["SETTING_FIELD_READ","SETTING_WORKFLOW_READ","SETTING_WORKFLOW_CONDITION_READ","CONTACT_STORAGE"]
            },
            {
              title:"Đồng bộ dữ liệu",
              path:"/setting/sync"
            },
            {
              title:"Dịch vụ gửi tin",
              path:"/setting/messaging"
            },
            {
              title:"Call Center",
              permission: ["CALL_CENTER"],
              path:"/setting/call-center"
            }

          ],
        },
      ],
    };
  },
  props: {
    menuOpen: {
      type: Boolean,
      require: true
    }
  },
  methods: {
    // Inline SVG icons for menu entries that can't use the icon-font
    // glyph. Colour follows active state (blue when selected, grey
    // otherwise) so it visually matches the icon-font entries.
    renderSvg(kind, active) {
      const stroke = active ? '#1769D7' : '#606266';
      if (kind === 'checklist') {
        // Clipboard with checkmarks — matches the "checklist" flaticon.
        return `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="${stroke}" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg">
          <rect x="5" y="4" width="14" height="17" rx="2"/>
          <path d="M9 3h6v3H9z" fill="${stroke}" stroke="none"/>
          <path d="M8.5 10.5l1.4 1.4L13 8.8"/>
          <path d="M8.5 16l1.4 1.4L13 14.3"/>
          <path d="M15 11h1.5"/>
          <path d="M15 16.5h1.5"/>
        </svg>`;
      }
      if (kind === 'event') {
        // Calendar with a highlighted event mark — matches the "event"
        // flaticon.
        return `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="${stroke}" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg">
          <rect x="3.5" y="5" width="17" height="15" rx="2"/>
          <path d="M3.5 9.5h17"/>
          <path d="M8 3v4"/>
          <path d="M16 3v4"/>
          <rect x="9" y="12.5" width="6" height="4" rx="0.8" fill="${stroke}" stroke="none"/>
        </svg>`;
      }
      return '';
    },
    selectActive(key) {
      this.pathActive = key;
    },
    isActive(path) {
      return path === this.pathActive;
    },
    onClickMenu2(e) {
      let url = "";
      switch (e) {
        case 1:
          url = "http://m.me/136475129549890";
          break;
        case 2:
          url = "https://docs.salework.net/salework-tai-lieu/salework-contact";
          break;
        case 3:
          url = "https://forms.gle/bca8WnFjJiuQhYgT7";
          this.showArrow = false;
          break;
      }
      window.open(url, "_blank");
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    resetActivity() {
      this.lastActivity = Date.now();

      if (this.showArrow && !this.hideTimer) {
        this.hideTimer = setTimeout(() => {
          this.showArrow = false;
          this.hideTimer = null;
        }, 10_000);
      }
    },

    checkInactivity() {
      this.inactiveTimer = setInterval(() => {
        const now = Date.now();
        const diff = now - this.lastActivity;

        // Nếu không thao tác trong 2 phút => hiện mũi tên
        if (diff > 120_000 && !this.showArrow) {
          this.showArrow = true;

          // Nếu vẫn không thao tác, tự ẩn sau 10s
          clearTimeout(this.hideTimer);
          this.hideTimer = setTimeout(() => {
            this.showArrow = false;
            this.hideTimer = null;
          }, 10_000);
        }
      }, 5000);
    },

    handleVisibility() {
      if (document.hidden) {
        this.visibilityChangeTime = Date.now();
      } else {
        const timeAway = Date.now() - this.visibilityChangeTime;
        if (timeAway > 120_000) {
          this.showArrow = true;

          clearTimeout(this.hideTimer);
          this.hideTimer = setTimeout(() => {
            this.showArrow = false;
            this.hideTimer = null;
          }, 10_000);
        }
        this.resetActivity();
      }
    },
    debounce(func, wait, immediate = false) {
      let timeout;
      return (...args) => {
        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          timeout = null;
          if (!immediate) func.apply(this, args);
        }, wait);
        if (callNow) func.apply(this, args);
      };
    },
  },
  mounted() {
    setTimeout(() => (this.showArrow = true), 600);
    setTimeout(() => (this.showArrow = false), 10000);

    this._debouncedReset = this.debounce(() => this.resetActivity(), 100, true);
    // Theo dõi hành vi người dùng
    window.addEventListener("mousemove", this._debouncedReset);
    window.addEventListener("keydown", this._debouncedReset);
    window.addEventListener("click", this._debouncedReset);
    document.addEventListener("visibilitychange", this.handleVisibility);

    // Bắt đầu kiểm tra định kỳ
    this.checkInactivity();
  },
  beforeDestroy() {
    clearInterval(this.inactiveTimer);
    clearTimeout(this.hideTimer);
    window.removeEventListener("mousemove", this._debouncedReset);
    window.removeEventListener("keydown", this._debouncedReset);
    window.removeEventListener("click", this._debouncedReset);
    document.removeEventListener("visibilitychange", this.handleVisibility);
  },
  watch:{
    '$route.path': {
      handler(newPath) {
        this.pathActive = newPath;
      },
      immediate: true,
    },
  },
  computed: {
    filteredMenuItems() {
      if (this.app.user.type === "ADMIN") {
        return this.menuItems;
      }
      if (this.app.role.permissionList) {
        return this.menuItems.map((item) => {
          if (item.subItems.length) {
            const filteredSubItems = item.subItems.filter((subItem) => {
              if (!subItem.permission) return true;
              return subItem.permission.some((role) => this.checkPermission(role));
            });
            return { ...item, subItems: filteredSubItems };
          }

          if (!item.permission || item.permission.length === 0) return item;

          if (item.permission.some((role) => this.checkPermission(role))) {
            return item;
          }
          return null; 
        })
        .filter((item) => item && (item.subItems.length === 0 || item.subItems.length > 0));
      }
      return [];
    },
    currentRoutePath() {
      return this.$router.currentRoute.path;
    },
  },
};
</script>

<style lang="scss">
.el-menu--collapse .el-submenu__icon-arrow {
  display: none !important;
}
.el-menu--collapse .el-submenu .el-submenu__title{
  padding: 0;
  padding-left: 8px!important;
}
.el-menu-item,
.el-submenu__title {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.14px;
  color: #373c41;
  height: 36px !important;
  border-radius: 5px;
  display: flex;
  align-items: center;
  &.is-active {
    background-color: #e1edfd !important;
    font-weight: 600 !important;
  }
  padding-left: 12px !important;
}
.sub-menu-title {
  margin-left: 26px;
}
.live-text {
  background-color: forestgreen;
  color: white;
  font-size: 10px;
  padding: 4px;
  font-weight: 500;
  border-radius: 4px;
  height: 20px;
  display: flex;
  align-items: center;
  margin-left: 0.25rem;
}
.menu-item-2 {
  &:hover {
    background-color: #e1edfd;
    color: #1769d7;
  }
  border-radius: 5px;
}
</style>

<style scoped>
.arrow-tooltip {
  position: absolute;
  top: -75px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
  width: max-content;
  max-width: 220px;
}

.arrow-box {
  background: linear-gradient(135deg, #1e88e5, #42a5f5); /* 💡 Hiệu ứng gradient nhẹ */
  color: #fff;
  padding: 10px 12px;
  border-radius: 10px;
  font-size: 13px;
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.25); /* 💡 Đổ bóng mạnh hơn */
  position: relative;
  display: inline-block;
  max-width: 160px;
  white-space: normal;
  word-wrap: break-word;
  line-height: 1.3;
  text-align: center;
  font-weight: 500;
  animation: bounce 1.4s ease-in-out infinite;
  border: 1px solid rgba(255, 255, 255, 0.3); /* 💡 Viền sáng tinh tế */
}

.arrow-down {
  position: absolute;
  bottom: -7px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-top: 7px solid #1e88e5; /* 💡 Giữ màu mũi tên đồng bộ */
  filter: drop-shadow(0 2px 2px rgba(0, 0, 0, 0.2));
}

@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
}

/* 💨 Thêm hiệu ứng fade + nhẹ glow khi xuất hiện */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.6s ease, transform 0.3s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: scale(0.95);
}

/* 💫 Hiệu ứng sáng nhẹ xung quanh */
.arrow-box::after {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: 10px;
  box-shadow: 0 0 8px rgba(66, 165, 245, 0.7);
  opacity: 0.4;
  animation: glow 2s ease-in-out infinite alternate;
}

@keyframes glow {
  from { opacity: 0.2; }
  to { opacity: 0.7; }
}

.el-menu {
  overflow: visible !important;
}

.sidebar-svg {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

</style>